import { IdNameApiModel } from '../../IdNameApiModel';
import { ActivityTypeListApiModel } from '../../site-settings/activity-types/ActivityTypeListApiModel';

export class ProgramSkillsSelectorsApiModel {
  public ProgramSkillHeadings: IdNameApiModel[];
  public SiteSkillHeadings: IdNameApiModel[];
  public ActivityTypes: ActivityTypeListApiModel[];
  public Phases: IdNameApiModel[];
  public Programs: IdNameApiModel[];

  public deserialize(data: Partial<ProgramSkillsSelectorsApiModel>): ProgramSkillsSelectorsApiModel {
    Object.assign(this, data);

    this.ActivityTypes = this.ActivityTypes.map((x) => new ActivityTypeListApiModel().deserialize(x));

    return this;
  }
}
